module.exports = __webpack_public_path__ + "img/PD1506092912084123648.11268acd.png";